import { Card, Group, Box, Text, Paper, Space } from '@mantine/core';
import { ExpandableValue } from './ExpandableValue';
import { ProjectHistoryDto } from '../../build/generated-sources/openapi';
import { formatDateTime, stringDateToFormattedString } from '../../core/util/Util';
import { HistoryFieldLabels } from './HistoryFieldLabels';

function formatIfDate(value?: string | null) {
  if (!value) return '—';

  const isoDateRegex = /^\d{4}-\d{2}-\d{2}/;

  if (isoDateRegex.test(value)) {
    const formatted = stringDateToFormattedString(value);
    return formatted || value;
  }

  return value;
}

export const HistoryCard = ({ h }: { h: ProjectHistoryDto }) => {
  const field = HistoryFieldLabels[h.fieldName || ''] || h.fieldName;

  return (
    <>
      <Card shadow="sm" p="lg" radius="md" withBorder ml={5} mr={5}>
        <Group justify="space-between" align={'end'}>
          <Box>
            <Text size="sm" c="dimmed">
              Autor:
            </Text>
            <Text size="sm" fw={600}>
              {h.changedByName || '—'}
            </Text>
            {h.changedByEmail && (
              <Text size="xs" c="dimmed" mt={2}>
                {h.changedByEmail}
              </Text>
            )}
          </Box>
          <Box style={{ textAlign: 'right' }}>
            <Text size="sm" c="dimmed">
              Datum a čas:
            </Text>
            <Text size="sm">{formatDateTime(h.changedAt)}</Text>
          </Box>
        </Group>
        <Group mt="sm" mb="sm">
          <Text fw={600}>Pole: {field}</Text>
        </Group>
        <Box mb="sm">
          <Text fw={500} size="sm" mb={4}>
            Původní hodnota:
          </Text>
          <Paper
            withBorder
            p="sm"
            radius="md"
            style={{
              backgroundColor: 'rgba(255, 0, 0, 0.06)'
            }}>
            <ExpandableValue text={formatIfDate(h.oldValue) || '—'} />
          </Paper>
        </Box>
        <Box>
          <Text fw={500} size="sm" mb={4}>
            Nová hodnota:
          </Text>
          <Paper
            withBorder
            p="sm"
            radius="md"
            style={{
              backgroundColor: 'rgba(0, 128, 0, 0.07)'
            }}>
            <ExpandableValue text={formatIfDate(h.newValue) || '—'} />
          </Paper>
        </Box>
      </Card>
      <Space h="lg" />
    </>
  );
};
